import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as agentActions from './../../../../actions/agentAction';
import Agent from './Agent';

const mapStateToProps = state => {
    return {
        agentState: state.agentReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getListAgents: (filters) => dispatch(agentActions.getListAgents(filters)),
        deleteAgentDetail: (agent, filters) => dispatch(agentActions.deleteAgentDetail(agent, filters)),
        getAgentListReports: (filters) => dispatch(agentActions.getAgentListReports(filters))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Agent));
